import script from "./editCountry.vue?vue&type=script&lang=ts&setup=true"
export * from "./editCountry.vue?vue&type=script&lang=ts&setup=true"

import "./editCountry.vue?vue&type=style&index=0&id=2c6daeaf&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c6daeaf"]])

export default __exports__